import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';
import apiClient from '../services/api';

const ChatBadge: React.FC = () => {
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = useCallback(async () => {
    try {
      const { data } = await apiClient.get('/api/chats/unread-count');
      setUnreadCount(data.unread_chats_count || 0);
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    const handleMarkedAsRead = () => fetchUnreadCount();
    window.addEventListener('chat-marked-as-read', handleMarkedAsRead);
    return () => {
      clearInterval(interval);
      window.removeEventListener('chat-marked-as-read', handleMarkedAsRead);
    };
  }, [fetchUnreadCount]);

  return (
    <Tooltip title="Чаты">
      <IconButton onClick={() => navigate('/chats')} color="inherit">
        <Badge badgeContent={unreadCount} color="error" max={99}>
          <ChatIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default ChatBadge;
